import { extractExperimentalData } from './extractExperimentalData';
/**
 * Returns the solubility of a compound
 * @param data Data of a compound data request to the PubChem API
 * @returns ExperimentalData
 */
export function getSolubility(data) {
    const solubility = extractExperimentalData(data, 'Solubility');
    return solubility;
}
//# sourceMappingURL=getSolubility.js.map